var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#f0f2f5"}},[_c('div',{staticClass:"main-panel"},[_c('dashboard-content',{staticClass:"dashboard-margin"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }